import authService from "@/services/authService";

const TOKEN_STORAGE_KEY = "TOKEN_STORAGE_KEY";

const state = {
  authenticating: false,
  error: false,
  token: null,
  showBadRequestAlert: false,
  errorMsg: null,
  registered: false,
  password_reset_link_sent: false,
  email_verified: null
};

const getters = {
  isAuthenticated: state => !!state.token
};

const actions = {
  registrationAction({ commit }, payload) {
    return authService
      .register(
        payload.first_name,
        payload.last_name,
        payload.postal_code,
        payload.is_stakeholder
      )
      .then(() => commit("REGISTER_SUCCESS"))
      .catch(() => commit("REGISTER_FAILURE"));
  },
  loginAction({ commit }, credentials) {
    commit("LOGIN_BEGIN");
    return authService
      .login(credentials.username, credentials.password)
      .then(({ data }) => commit("SET_TOKEN", data.token))
      .then(() => commit("LOGIN_SUCCESS"))
      .then(() => commit("HIDE_BAD_REQUEST_ALERT"))
      .catch(() => commit("LOGIN_FAILURE"));
  },
  logout({ commit }) {
    return authService
      .logout()
      .then(() => commit("LOGOUT"))
      .finally(() => commit("REMOVE_TOKEN"));
  },
  initialize({ commit }) {
    const token = localStorage.getItem("TOKEN_STORAGE_KEY");
    if (token) {
      commit("SET_TOKEN", token);
    } else {
      commit("REMOVE_TOKEN");
    }
  },
  passwordReset({ commit }, email) {
    return authService
      .resetPassword(email)
      .then(() => commit("PASSWORD_RESET_LINK_SENT"))
      .catch(() => commit("PASSWORD_RESET_FAILURE"));
  },
  showBadRequestAlert({ commit }, errorMsg) {
    commit("SHOW_BAD_REQUEST_ALERT", errorMsg);
  },
  setToken({ commit }, token) {
    commit("SET_TOKEN", token);
  },
  confirmEmail({ commit }, key) {
    return authService
      .confirmEmail(key)
      .then(() => commit("EMAIL_VERIFIED_SUCCEEDED"))
      .catch(() => commit("EMAIL_VERIFIED_FAILED"));
  }
};

const mutations = {
  LOGIN_BEGIN(state) {
    state.authenticating = true;
    state.error = false;
  },
  LOGIN_FAILURE(state) {
    state.authenticating = false;
    state.error = true;
  },
  REGISTER_SUCCESS(state) {
    state.registered = true;
    state.error = false;
  },
  REGISTER_FAILURE(state) {
    state.registered = false;
    state.error = true;
  },
  LOGIN_SUCCESS(state) {
    state.authenticating = false;
    state.error = false;
  },
  LOGOUT(state) {
    state.authenticating = false;
    state.error = false;
  },
  SET_TOKEN(state, token) {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
    state.token = token;
  },
  REMOVE_TOKEN(state) {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    state.token = null;
  },
  SHOW_BAD_REQUEST_ALERT(state, errorMsg) {
    state.errorMsg = errorMsg;
    state.showBadRequestAlert = true;
  },
  HIDE_BAD_REQUEST_ALERT(state) {
    state.showBadRequestAlert = false;
  },
  PASSWORD_RESET_LINK_SENT(state) {
    state.password_reset_link_sent = true;
    state.error = false;
  },
  PASSWORD_RESET_FAILURE(state) {
    state.password_reset_link_sent = false;
    state.error = true;
  },
  EMAIL_VERIFIED_SUCCEEDED(state) {
    state.email_verified = true;
  },
  EMAIL_VERIFIED_FAILED(state) {
    state.email_verified = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
